<template>
  <div class="download-page">
    <!-- 微信内：箭头固定到整页右上角，放在 container 外避免受 transform 影响 -->
    <template v-if="isWeChat">
      <div class="arrow-guide">
        <span class="arrow-emoji">⬆</span>
        <p class="arrow-text">请点击右上角 ··· 通过浏览器打开下载</p>
      </div>
    </template>
    <div class="container" :class="{ 'fade-in': mounted }">
      <!-- 微信内：展示引导 -->
      <template v-if="isWeChat">
        <div class="guide-block">
          <h1 class="title">请使用浏览器打开</h1>
          <p class="desc">当前在微信内无法直接下载安装包，请点击右上角「···」菜单，选择「在浏览器中打开」后即可下载。</p>
          <div class="steps">
            <div class="step-item">
              <span class="step-num">1</span>
              <span>点击右上角「···」</span>
            </div>
            <div class="step-item">
              <span class="step-num">2</span>
              <span>选择「在浏览器中打开」</span>
            </div>
            <div class="step-item">
              <span class="step-num">3</span>
              <span>在浏览器中即可下载安装</span>
            </div>
          </div>
        </div>
      </template>
      <!-- 非微信：展示下载中/已跳转 -->
      <template v-else>
        <div class="direct-block">
          <h1 class="title">正在跳转下载</h1>
          <p class="desc">若未自动开始下载，请<a :href="safeDownloadUrl" class="download-link" @click.prevent="triggerDownload">点击此处</a>。</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'DownloadPage',
  data() {
    return {
      isWeChat: false,
      downloadUrl: '',
      mounted: false
    }
  },
  computed: {
    safeDownloadUrl() {
      return this.downloadUrl || '#'
    }
  },
  mounted() {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''
    this.isWeChat = /MicroMessenger/i.test(ua)
    this.downloadUrl = this.decodeUrl(this.$route.query.url)

    this.$nextTick(() => {
      this.mounted = true
    })

    if (!this.isWeChat && this.downloadUrl) {
      this.triggerDownload()
    }
  },
  methods: {
    decodeUrl(url) {
      if (!url || typeof url !== 'string') return ''
      try {
        return decodeURIComponent(url)
      } catch {
        return url
      }
    },
    triggerDownload() {
      if (!this.downloadUrl) return
      window.location.href = this.downloadUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.download-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f6fc 0%, #e8f0f8 100%);
  padding: 24px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  max-width: 480px;
  width: 100%;
  background: #fff;
  padding: 32px 24px;
  box-shadow: 0 4px 20px rgba(27, 88, 152, 0.12);
  border-radius: 12px;
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.5s ease, transform 0.5s ease;

  &.fade-in {
    opacity: 1;
    transform: translateY(0);
  }
}

.title {
  font-size: 22px;
  color: #1B5898;
  text-align: center;
  margin-bottom: 16px;
  animation: slideDown 0.5s ease;
}

.desc {
  font-size: 15px;
  color: #555;
  line-height: 1.7;
  margin-bottom: 24px;
  animation: fadeInUp 0.5s ease 0.1s both;
}

.arrow-guide {
  position: fixed;
  top: 12px;
  right: 12px;
  width: 200px;
  z-index: 1000;
  text-align: right;
  pointer-events: none;
}

.arrow-emoji {
  display: block;
  font-size: 32px;
  line-height: 1;
  margin-bottom: 6px;
  animation: arrowPulse 2s ease-in-out infinite;
}

.arrow-text {
  font-size: 20px;
  color: #1B5898;
  font-weight: 500;
  margin: 0;
  line-height: 1.4;
  animation: fadeInUp 0.5s ease 0.3s both;
}

@keyframes arrowPulse {
  0%, 100% {
    opacity: 1;
    transform: translate(0, 0);
  }
  50% {
    opacity: 0.85;
    transform: translate(-4px, -2px);
  }
}

.guide-block .steps {
  margin: 24px 0;
}

.step-item {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  font-size: 15px;
  color: #333;
  animation: fadeInUp 0.4s ease both;

  &:nth-child(1) { animation-delay: 0.2s; }
  &:nth-child(2) { animation-delay: 0.3s; }
  &:nth-child(3) { animation-delay: 0.4s; }
}

.step-num {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #1B5898;
  color: #fff;
  border-radius: 50%;
  margin-right: 12px;
  font-weight: 600;
}

.direct-block .download-link {
  color: #1B5898;
  text-decoration: underline;
  font-weight: 500;

  &:hover {
    text-decoration: none;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 480px) {
  .download-page {
    padding: 16px;
  }
  .container {
    padding: 24px 20px;
  }
  .title {
    font-size: 20px;
  }
  .desc {
    font-size: 14px;
  }
}
</style>
